var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:'icon' + (_vm.mode ? ' uk-text-' + _vm.mode : '')},[_c('span',{class:_vm.classGenerator(),attrs:{"uk-icon":'icon: ' + _vm.icon + '; ratio: ' + _vm.ratio,"uk-tooltip":_vm.tooltip ? 'title:' + _vm.tooltip : ''}})])
}
var staticRenderFns = []

export { render, staticRenderFns }